export * from "./ComparisonOperator";
export * from "./DatabaseTables";
export * from "./Primitive";
export * from "./sqliteEquals";
export * from "./sqliteGreaterThan";
export * from "./SqliteQuerySpec";
export * from "./TableSpec";
export * from "./TablesSpec";

export type SqliteType = "null" | "integer" | "real" | "text" | "blob";

export function getSqliteType(value: unknown): SqliteType {
	if (value === null || value === undefined) {
		return "null";
	}
	if (typeof value === "number") {
		return Number.isInteger(value) ? "integer" : "real";
	}
	if (typeof value === "boolean") {
		return "integer";
	}
	if (Buffer.isBuffer(value)) {
		return "blob";
	}
	return "text";
}

export function isNumericType(type: SqliteType): boolean {
	return type === "integer" || type === "real";
}
